import React from 'react'
import Hero from './Hero'
import Services from './Services'
import Blog from './Blog'
import Feature from './Feature'
import Testimonials from './Testimonials'
import Mission from './Mission'
import Aboutnew from './Aboutnew'
import Facts from './Facts'
// import Demo from './DemoWeb'


const HomePage = () => {
  return (
    <React.Fragment>
        <Hero />
        <Services />
        <Blog />
        <Mission />
        <Aboutnew hideAbout />
        <Feature />
        <Facts />
        <Testimonials />
        {/* <Demo /> */}
       
        
    </React.Fragment>
  )
}

export default HomePage